import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { PaymentState } from './state/payment.state';
import { ModelsModule } from '@nibtravel/shared/util/models';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([PaymentState]), ModelsModule],
})
export class PaymentStateModule {}
